import { useEffect, useState } from "react";
import { Plus, Pencil, Trash2, RefreshCw, TicketPercent } from "lucide-react";
import { toast } from "sonner";
import { Rail } from "../components/Rail";
import api, { apiError } from "../lib/api";
import { Field, inputCls, btnMint, btnGhost } from "../lib/ui";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";

const EMPTY = { code: "", name: "", description: "", terms: "", active: true };

export default function Promotions() {
  const [items, setItems] = useState([]);
  const [modal, setModal] = useState(null);
  const load = () => api.get("/promos").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      if (modal.id) await api.put(`/promos/${modal.id}`, modal);
      else await api.post("/promos", modal);
      toast.success("Promo disimpan, katalog AI diperbarui");
      setModal(null);
      load();
    } catch (err) { toast.error(apiError(err)); }
  };

  const del = async (id) => {
    await api.delete(`/promos/${id}`);
    toast.success("Promo dihapus");
    load();
  };

  return (
    <div className="flex h-screen bg-ink text-paper">
      <Rail />
      <main className="flex-1 overflow-y-auto">
        <header className="sticky top-0 z-10 flex items-center justify-between border-b border-white/5 bg-ink/80 px-8 py-5 backdrop-blur-md">
          <div>
            <h1 className="text-xl font-semibold">Promo</h1>
            <p className="text-sm text-muted">Promo aktif yang ditawarkan AI ke pelanggan</p>
          </div>
          <div className="flex gap-3">
            <button data-testid="promos-reindex-btn" onClick={() => api.post("/catalog/reindex").then(() => toast.success("Katalog AI di-index ulang"))} className={btnGhost}><RefreshCw size={14} /> Re-index</button>
            <button data-testid="promos-add-btn" onClick={() => setModal({ ...EMPTY })} className={btnMint}><Plus size={15} /> Tambah Promo</button>
          </div>
        </header>
        <div className="grid gap-4 p-8 sm:grid-cols-2 xl:grid-cols-3" data-testid="promos-grid">
          {items.map((p) => (
            <div key={p.id} className="rounded-2xl border border-white/5 bg-panel p-5 transition-colors hover:border-white/15">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-mint/10 text-mint"><TicketPercent size={18} /></span>
                <div className="min-w-0">
                  <p className="truncate font-semibold">{p.name}</p>
                  <span className="rounded bg-white/5 px-1.5 py-0.5 font-mono text-[10px] text-faint">{p.code}</span>
                </div>
              </div>
              <p className="mt-3 text-sm text-muted">{p.description}</p>
              <p className="mt-1 text-xs text-faint">{p.terms}</p>
              <div className="mt-3 flex justify-end gap-2">
                <button data-testid={`promo-edit-${p.code}`} onClick={() => setModal({ ...p })} className="rounded-lg p-2 text-faint transition-colors hover:bg-white/5 hover:text-paper"><Pencil size={14} /></button>
                <button data-testid={`promo-delete-${p.code}`} onClick={() => del(p.id)} className="rounded-lg p-2 text-faint transition-colors hover:bg-white/5 hover:text-red-400"><Trash2 size={14} /></button>
              </div>
            </div>
          ))}
          {!items.length && <p className="text-sm text-faint">Belum ada promo aktif.</p>}
        </div>
      </main>

      <Dialog open={!!modal} onOpenChange={(o) => !o && setModal(null)}>
        <DialogContent className="border-white/10 bg-panel2 text-paper sm:rounded-2xl">
          <DialogHeader><DialogTitle>{modal?.id ? "Edit Promo" : "Tambah Promo"}</DialogTitle></DialogHeader>
          {modal && (
            <form onSubmit={save} className="space-y-4">
              <Field label="Kode"><input data-testid="promo-code-input" className={inputCls} required value={modal.code} onChange={(e) => setModal({ ...modal, code: e.target.value.toUpperCase() })} /></Field>
              <Field label="Nama"><input data-testid="promo-name-input" className={inputCls} required value={modal.name} onChange={(e) => setModal({ ...modal, name: e.target.value })} /></Field>
              <Field label="Deskripsi"><input data-testid="promo-desc-input" className={inputCls} value={modal.description} onChange={(e) => setModal({ ...modal, description: e.target.value })} /></Field>
              <Field label="Syarat & Ketentuan"><textarea data-testid="promo-terms-input" rows={2} className={inputCls} value={modal.terms} onChange={(e) => setModal({ ...modal, terms: e.target.value })} /></Field>
              <button data-testid="promo-save-btn" className={`${btnMint} w-full`}>Simpan</button>
            </form>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
